import type { App, ChainInfo, NetworkInfo } from "@alch/dx-entities";
import sortBy from "lodash/sortBy";
import { useMemo } from "react";
import NetworkItem from "./NetworkItem.js";

export enum NetworkSort {
  Name = "name",
  Order = "order",
}

export default function useNetworkItems({
  networkInfos,
  chainInfo,
  app,
  sort,
}: {
  networkInfos: NetworkInfo[];
  chainInfo?: ChainInfo;
  app?: App;
  sort?: NetworkSort;
}) {
  return useMemo(
    () =>
      sortBy(
        Object.values(networkInfos),
        (n) => {
          // Move disabled networks to the end
          return app?.networkAllowlist.includes(n.id) ? 0 : 1;
        },
        (n) => {
          switch (sort) {
            case NetworkSort.Name:
              return n.name;
            case NetworkSort.Order:
            default:
              // Keep the order as is
              return 0;
          }
        },
      ).map((networkInfo) => {
        const disabled =
          !!app?.networkAllowlist &&
          !app.networkAllowlist.includes(networkInfo.id);

        return {
          disabled,
          value: networkInfo.id,
          label: networkInfo.name,
          displayLabel: (
            <NetworkItem
              networkInfo={networkInfo}
              chainInfo={chainInfo}
              disabled={disabled}
              app={app}
            />
          ),
        };
      }),
    [networkInfos, chainInfo, sort, app],
  );
}
